module.exports = __webpack_public_path__ + "img/transactions.3a5d298d.svg";